import { render, staticRenderFns } from "./UserComment.vue?vue&type=template&id=7a35baea&scoped=true"
import script from "./UserComment.vue?vue&type=script&lang=js"
export * from "./UserComment.vue?vue&type=script&lang=js"
import style0 from "./UserComment.vue?vue&type=style&index=0&id=7a35baea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a35baea",
  null
  
)

export default component.exports